module.exports = __webpack_public_path__ + "static/BrandonGrotesque-Thin-6eb30e4c13ebe142b1194a646895a94e.woff";